<template>
  <div class="container">
    <p>
      Diseña o importa plantillas de correo para enviar campañas de marketing desde estrategias.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>

    <a-form class="form" layout="vertical" :model="formState">
      <a-form-item name="name">
        <a-input class="search" v-model:value="formState.name" placeholder="Buscar por nombre">
          <template #prefix>
            <SearchOutlined />
          </template>
        </a-input>
      </a-form-item>

      <a-form-item class="type">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          class="select"
          v-model:value="formState.type"
        >
          <a-select-option :value="''">Todos los tipos</a-select-option>
          <a-select-option :value="TemplateType.Html">Plantilla HTML</a-select-option>
          <a-select-option :value="TemplateType.Default"
            >Creado desde {{ ProductName }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <a-form-item class="state">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          class="select"
          v-model:value="formState.state"
        >
          <a-select-option :value="''">Todos los estados</a-select-option>
          <a-select-option :value="TemplateState.Active">Activo</a-select-option>
          <a-select-option :value="TemplateState.Inactive">Inactivo</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>

    <CustomScrollbar height="calc(100vh - 205px)">
      <TemplatesList :templates="templates" @update="fetchTemplatesList" />
    </CustomScrollbar>
  </div>
</template>

<script setup lang="ts">
import { reactive, onMounted, ref, watch } from "vue";
import { SearchOutlined } from "@ant-design/icons-vue";

import { FiltersDto } from "@/@types/flows/emailTemplates/dtos";
import { emailTemplateService } from "@/app/flows/emailTemplates/services/EmailTemplate.service";
import { Template, TemplateState, TemplateType } from "@/@types/flows/emailTemplates";

import TemplatesList from "@/app/flows/emailTemplates/components/lists/TemplatesList.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { debounce } from "lodash";
import { ProductName } from "@/app/shared/utils/constants";

const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/correo/plantillas-de-correo-1/`;

const formState: FiltersDto = reactive({
  name: "",
  type: "",
  state: "",
});

const templates = ref<Template[]>([]);

const fetchTemplatesList = async () => {
  templates.value = await emailTemplateService.getTemplatesList(formState);
};

watch(
  formState,
  debounce(() => {
    fetchTemplatesList();
  }, 400)
);

onMounted(() => fetchTemplatesList());
</script>

<style scoped lang="sass">
.container
  padding: 12px 22px

p
  margin-bottom: 20px
  color: $gray-8

.form
  display: flex
  gap: 8px
  margin-bottom: 20px

  .ant-form-item
    margin: 0

  .search
    min-width: 250px

  .select
    min-width: 180px
</style>
